export const DEVICE_PREVIEWS = {
  desktop: {
    width: "100%",
    maxWidth: 1180,
    minHeight: 720,
    frameClass: "rounded-xl",
  },
  tablet: {
    width: 768,
    maxWidth: "100%",
    minHeight: 900,
    frameClass: "rounded-2xl",
  },
  mobile: {
    width: 390,
    maxWidth: "100%",
    minHeight: 760,
    frameClass: "rounded-[2rem]",
  },
};

export function getPreviewDeviceConfig(device) {
  return DEVICE_PREVIEWS[device] || DEVICE_PREVIEWS.desktop;
}

export function getInitialPreviewDevice() {
  if (typeof window === "undefined") return "desktop";
  return window.matchMedia?.("(max-width: 640px)")?.matches ? "mobile" : "desktop";
}

export function withPreviewDevice(layoutConfig, device) {
  return {
    ...(layoutConfig || {}),
    __previewDevice: device,
  };
}
